import { SearcherState } from '@vueling-ng/vy-cdk-searcher';
import { ProfessionalRoute } from 'app/core/common/models/professionals-route.config';
import { QuickFilters } from 'app/views/booking-list/models/filters.model';

declare global {
  interface Window {
    [key: string]: unknown;
  }
}

interface IContainerPage {
  id: string;
}

export type StatusBookingDigitalData = 'bookinglistflown' | 'bookingcancel' | 'SMART' | 'DESKTOP';
export const InternalStatusBookingDigitalData: Record<StatusBookingDigitalData, string> = {
  bookinglistflown: 'bookinglistflown',
  bookingcancel: 'bookingcancel',
  SMART: 'SMART',
  DESKTOP: 'DESKTOP'
};

export interface PageTrackingDigitalData {
  user: GaDigitalDataUser;
  page: GaDigitalDataPage;
}
export interface GaDigitalDataUser {
  abdesa: string;
  abtestptvancdes: string;
  clienttype: string;
  geo: string;
  usercountry: string;
  userid: string;
  userid2: string;
  utmcampaign: string;
  utmcontent: string;
  utmmedium: string;
  utmsource: string;
  utmterm: string;
}
export interface GaDigitalDataPage {
  language: string;
  pagename: string;
  acceptnews: string;
  errortype: string;
  languagecriteo: string;
  platformtype: string;
  section: string;
  subsection: string;
  homebanner: string;
  technology: string;
  requesttimestamp: Date;
  container: IContainerPage;
  timeofday: string;
}

export interface DataLayerEntry {
  event: string;
}

export const EmptyDigitalDataPage: GaDigitalDataPage = {
  pagename: 'notapply',
  language: 'notapply',
  acceptnews: 'notapply',
  errortype: 'notapply',
  languagecriteo: 'notapply',
  platformtype: 'notapply',
  section: 'notapply',
  subsection: 'notapply',
  homebanner: 'notapply',
  technology: 'notapply',
  requesttimestamp: new Date(),
  container: {
    id: 'notapply'
  },
  timeofday: 'notapply'
};

export const EmptyDigitalDataUser: GaDigitalDataUser = {
  userid: 'notapply',
  abdesa: 'notapply',
  abtestptvancdes: 'notapply',
  clienttype: 'notapply',
  geo: 'notapply',
  usercountry: 'notapply',
  userid2: 'notapply',
  utmcampaign: 'notapply',
  utmcontent: 'notapply',
  utmmedium: 'notapply',
  utmsource: 'notapply',
  utmterm: 'notapply'
};

export const dataLayerName = 'dataLayer';
export const digitalDataName = 'digitalData';

export interface SearcherTrackingDigitalData {
  event: 'search_start';
  flight_type: GaFlightType;
  trip_duration: number;
  item_id: GaItemId;
  country_route: string;
  pax_number: number;
  adult_count: number;
  child_count: number;
  baby_count: number;
  extra_seat: number;
  days_in_advance: number;
  departure_flight: string;
  return_flight?: string;
  departuredate: string;
  returndate?: string;
  departureoriginstationiata: string;
  departurearrivalstationiata: string;
  returnoriginstationiata?: string;
  returnarrivalstationiata?: string;
}

export enum GaItemId {
  Flight = 'flight'
}

export enum GaFlightType {
  OneWay = 'one way',
  RoundTrip = 'round trip'
}

export interface PageViewEventFields {
  route: ProfessionalRoute;
  filter?: QuickFilters;
}

export type EventFields = SearcherState | PageViewEventFields;
export type GaEvents = 'search_start' | 'page_view';
